import { Box, ButtonWithLoading } from '@edreamsodigeo/prisma-design-system';
import React from 'react';
import { withDatameshClick } from '@/HOC/withDatamesh';
import { useTranslation, createFeature } from '@edreamsodigeo/frontend-core';
import { PRIME_FIRST_PHASE_2_DESKTOP } from '@/versionedComponents';

const ButtonWithTracking = withDatameshClick(ButtonWithLoading, 'home:button');

const PrimeAcquisitionHomeButtonPhase2 = (props) => {
  return <HomePageButtonContactDetails {...props} disabled={false} />;
};

export const VersionedHomeContactDetailsButton =
  PrimeAcquisitionHomeButtonPhase2;

export const HomePageButtonContactDetails = ({
  onContinueHandler,
  loading,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <Box px="base">
      <ButtonWithTracking
        disabled={disabled}
        type="primary"
        size="large"
        sx={{ fontWeight: '500' }}
        loading={loading}
        onClick={onContinueHandler}
        nativeType="button"
        fullWidth
        id="pf-home-button"
        data-testid={loading ? 'home_loading' : 'home_idle'}
      >
        {t('home.continue')}
      </ButtonWithTracking>
    </Box>
  );
};

export const VersionedHomeContactDetailsButtonDesktop = createFeature({
  name: PRIME_FIRST_PHASE_2_DESKTOP,
  variations: [
    HomePageButtonContactDetails,
    PrimeAcquisitionHomeButtonPhase2,
    PrimeAcquisitionHomeButtonPhase2,
  ],
  version: 1,
});
